import type { ApiDocsSmartSentimentAssetDto } from "@tradingApp/api/types/ApiDocs";
import type { InsightsAssetsTableSort } from "@tradingApp/components/Insights/types";

export function insightsSortByTradersCount(
  a: ApiDocsSmartSentimentAssetDto,
  b: ApiDocsSmartSentimentAssetDto,
  direction: InsightsAssetsTableSort["direction"],
): number {
  const aVolume = a.totalTradersCount;
  const bVolume = b.totalTradersCount;

  return direction === "asc" ? aVolume - bVolume : bVolume - aVolume;
}

export function insightsSortByTradersPercent(
  a: ApiDocsSmartSentimentAssetDto,
  b: ApiDocsSmartSentimentAssetDto,
  direction: InsightsAssetsTableSort["direction"],
): number {
  const aLongPercent = a?.sentiment?.tradersPercent;
  const bLongPercent = b?.sentiment?.tradersPercent;

  if (typeof aLongPercent !== "number" || typeof bLongPercent !== "number") {
    return 0;
  }

  return direction === "asc"
    ? aLongPercent - bLongPercent
    : bLongPercent - aLongPercent;
}
